/**
 * Maps a presigned URL (without query string) back to its 'workspace-asset://uuid'
 * reference, so resolved images can be rewritten to asset refs when saving.
 */
export var resolvedAssetCache = new Map();

/** Prefix marking an image src as a workspace asset reference. */
export var ASSET_PREFIX = "workspace-asset://";